/* Side panel and autoplay rules for the inline player (pure functions). */

export type PanelTab = 'next' | 'comments';

/** Same rule as the album-video page: comments only for published videos with comments switched on. */
export function commentsEnabledFor(video: any): boolean {
  return video?.enable_comments === 1 && video?.publish === 1;
}

/** Open on Comments only when there is nothing else to pick from; otherwise Up next. */
export function defaultPanelTab(videoCount: number, commentsEnabled: boolean): PanelTab {
  return videoCount <= 1 && commentsEnabled ? 'comments' : 'next';
}

/** The next video after `currentId` that the fan can play right now (never a paid or locked one). */
export function nextPlayableVideo(videos: any[], currentId: any, canPlay: (video: any) => boolean): any | null {
  const list = videos || [];
  const index = list.findIndex(video => video?.stream_info?.id === currentId);
  if (index < 0) return null;
  for (let i = index + 1; i < list.length; i++) {
    if (canPlay(list[i])) return list[i];
  }
  return null;
}

/** 75 → "1:15", 3725 → "1:02:05". */
export function formatPlayerTime(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
}
